@if (show) {
  <div data-cy="draft-accept-refuse-modal" class="refuse-confirm-container">
    <div>
      {{ 'modal.draftAcceptRefuseConfirm.text1' | translate }}
      {{ (type === 'accept'
      ? 'modal.draftAcceptRefuseConfirm.text2a'
      : type === 'refuse'
      ? 'modal.draftAcceptRefuseConfirm.text2b'
      : '') | translate }}
      {{ (portfolio?.portfolioType === 'STRATEGY'
      ? 'modal.draftAcceptRefuseConfirm.text3a'
      : portfolio?.portfolioType === 'PORTFOLIO'
      ? 'modal.draftAcceptRefuseConfirm.text3b'
      : '') | translate }}
      "{{ portfolio?.name }}"?
    </div>
    <div class="accept-reject-btns-container">
      <libero-button
        label="{{ 'global.buttons.yes' | translate }}"
        btnClasses="btn--primary"
        (click)="onYesBtnClick()"
        data-cy="draft-accept-refuse-yes-btn"
        [preloader]="!!loadingConfirm"
      ></libero-button>
      <libero-button
        label="{{ 'global.buttons.no' | translate }}"
        btnClasses="btn--danger"
        (click)="onNoBtnClick()"
      ></libero-button>
    </div>
  </div>
}
